export const DEFAULT_API_URL = '/api';
export const DEFAULT_TIMEOUT = 300 * 1000;

export const METHOD_CREATE = 'post';
export const METHOD_READ = 'get';
export const METHOD_UPDATE = 'put';
export const METHOD_DELETE = 'delete';

export const OAUTH_CLIENT_ID = '';
export const OAUTH_CLIENT_SECRET = '';